// ============================================================
// 管理端路由实例
// 菜单走 GET /manage/user/info → menus
// ============================================================
import { createDynamicRouter } from "@shared/router";
import Layout from "@shared/layout/index.vue";
import { fetchCurrentUserInfo } from "@app/api/user";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { staticRoutes } from "./routes";
import "./routePages";

/**
 * 顶栏 InSiteMessageDrawer / 站内信详情页的「去处理」/「查看全部」等入口，
 * 与权限 / 动态菜单无关，必须始终可访问：
 */
const guaranteedRoutes = [
    {
        path: "/inSiteMessage",
        component: Layout,
        meta: { hidden: true },
        children: [
            {
                path: "list",
                name: "InSiteMessageList",
                component: () => import("@app/views/inSiteMessage/list/index.vue"),
                meta: { title: "消息列表", hidden: true },
            },
            {
                path: "detail",
                name: "InSiteMessageDetail",
                component: () => import("@app/views/inSiteMessage/detail/index.vue"),
                meta: { title: "消息详情", hidden: true },
            },
        ],
    },
];

const router = createDynamicRouter({
    staticRoutes,
    guaranteedRoutes,
    fetchUserMenus: async () => {
        const data = await fetchCurrentUserInfo();
        useCurrentUserStore().hydrateFromInfo(data);
        return { menus: data.menus ?? [], buttonPages: data.buttonPages ?? [] };
    },
    layout: Layout,
    whiteList: ["/login", "/404", "/403"],
    baseTitle: import.meta.env.VITE_APP_TITLE || "1P管理端",
    loginPage: () => import("@app/views/login.vue"),
    requireAuth: true,
});

export default router;
